module.exports = JSON.parse('{"File name":"文件名","Image size":"图片大小","Include annotations":"包含注释","Include warning message":"包含警告信息"}')